import { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { Drawer, Divider, List, ListSubheader, ListItem, ListItemButton, ListItemIcon, ListItemText, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';

import useNav from 'app/hooks/useNav';
import GlobalSearchModal from 'app/components/GlobalSearch/GlobalSearchModal';

const SideNav = props => {
  const {
    isOpen,
    onOpen,
    onClose,
    drawerWidth
  } = props;

  const account = useSelector(state => state.portalReducer.account);
  const isKioskMode = account.feature_flags.kiosk_mode;

  const {
    getNavLinks,
    getReportMenuLinks,
    getAccountMenuLinks
  } = useNav();

  const navLinks = getNavLinks();
  const reportMenuLinks = getReportMenuLinks();
  const accountMenuLinks = getAccountMenuLinks();

  const history = useHistory();
  const goToLink = link => {
    if (link.path) {
      history.push(link.path);
    } else {
      link.onClick && link.onClick();
    }
  }

  const [searchIsOpen, setSearchOpen] = useState(false);
  const onSearchOpen = () => setSearchOpen(true);
  const onSearchClose = () => setSearchOpen(false);

  let sx = {
    width: drawerWidth,
    flexShrink: 0,
    '& .MuiDrawer-paper': {
      width: drawerWidth,
      height: `calc(100vh - 64px)`,
      marginTop: '64px',
      boxSizing: 'border-box',
    }
  }

  let headerSx = { position: 'fixed', top: 0, left: 0, width: drawerWidth, borderRight: '1px solid rgba(0, 0, 0, 0.12)', overflow: 'hidden' };

  return (
    <Drawer variant="permanent" open={isOpen} onClose={onClose} sx={sx}>
      <List sx={{ paddingTop: 0 }}>
        <ListItem button component="a" onClick={isOpen ? onClose : onOpen} sx={headerSx}>
          <ListItemButton sx={{'&:hover': { background: 'none' }}}>
            <ListItemIcon>
              <MenuIcon />
            </ListItemIcon>
            <ListItemText primary="Partner Portal" />
          </ListItemButton>
          <Divider />
        </ListItem>
        <ListItem button component="a" onClick={searchIsOpen ? onSearchClose : onSearchOpen}>
          <ListItemButton sx={{'&:hover': { background: 'none' }}}>
            <ListItemIcon>
              <SearchIcon />
            </ListItemIcon>
            <ListItemText primary="Search" />
          </ListItemButton>
        </ListItem>
        <ListSubheader sx={{ lineHeight: 3 }}>{ isKioskMode ? 'Kiosk' : 'Nav' }</ListSubheader>
        {navLinks.map((link, i) => (
          <ListItem key={link.label + i} button component="a" title={link.label} onClick={() => goToLink(link)}>
            <ListItemButton sx={{'&:hover': { background: 'none' }}}>
              <ListItemIcon>
                {link.icon}
              </ListItemIcon>
              <ListItemText primary={link.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListSubheader>Reports</ListSubheader>
        {reportMenuLinks.map((link, i) => (
          <ListItem key={link.label + i} button component="a" title={link.label} onClick={() => goToLink(link)}>
            <ListItemButton sx={{'&:hover': { background: 'none' }}}>
              <ListItemIcon>
                {link.icon}
              </ListItemIcon>
              <ListItemText primary={link.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        <ListSubheader>Account</ListSubheader>
        {accountMenuLinks.map((link, i) => (
          <ListItem key={link.label + i} button component="a" title={link.label} onClick={() => goToLink(link)}>
            <ListItemButton sx={{'&:hover': { background: 'none' }}}>
              <ListItemIcon>
                {link.icon}
              </ListItemIcon>
              <ListItemText primary={link.label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <GlobalSearchModal
        isOpen={searchIsOpen}
        onClose={onSearchClose}
        drawerWidth={drawerWidth}
      />
    </Drawer>
  );
}

export default SideNav;
